export default __webpack_public_path__ + "static/media/frg--bbq-entertaining.8d7f75f7.png";